if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();

        this.storageKey = this.dataset.storageKey || 'recently-viewed';
        this.itemClass = this.dataset.itemClass || 'swiper-slide';
        this.limit = Number(this.dataset.limit) || null;
        this.storage = localStorage.getItem(this.storageKey);
        this.store = this.storage !== null ? JSON.parse(this.storage) : {};

        this.list = this.querySelector('[data-products-list]');

        /** @type {import('./types').ItemCarousel | null} */
        this.carousel = this.querySelector('item-carousel');
      }

      connectedCallback() {
        if (this.store && this.list) {
          const products = Object.values(this.store).reverse();
          const limitedProducts = this.limit ? products.slice(0, this.limit) : products;

          if (limitedProducts.length > 0) {
            this.list.innerHTML = '';

            limitedProducts.forEach((product) => {
              const li = document.createElement('li');
              li.classList.add(this.itemClass);
              li.innerHTML = product;
              this.list?.append(li);
            });
          }

          if (this.carousel) {
            const instance = this.carousel.instance;

            if (instance) {
              instance.update();
            }
          }
        }
      }
    },
  );
}
